import { UI_ArticleText } from 'ui/components/2-molecules/Article/ArticleText/ArticleText';

interface Props {
	content: {
		properties: {
			content: string;
		};
	};
}

export const ArticleText = ({ content }: Props) => <UI_ArticleText {...content?.properties} />;
